import { useState } from 'react'

export default function useModal({ defaultVisible = true }) {
  const [modalOpen, setModalOpen] = useState(defaultVisible)

  const toggle = () => setModalOpen(!modalOpen)

  return [modalOpen, setModalOpen, toggle]
}
